<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-equal`]" width="1em" height="1em" v-bind="$attrs"><path d="M13.1943 10.4609C13.5616 10.4609 13.8594 10.7587 13.8594 11.126C13.8594 11.4932 13.5616 11.791 13.1943 11.791H2.80566C2.43839 11.791 2.14062 11.4932 2.14062 11.126C2.14062 10.7587 2.43839 10.4609 2.80566 10.4609H13.1943ZM13.1943 4.21094C13.5616 4.21094 13.8594 4.50871 13.8594 4.87598C13.8594 5.24325 13.5616 5.54102 13.1943 5.54102H2.80566C2.43839 5.54102 2.14062 5.24325 2.14062 4.87598C2.14062 4.50871 2.43839 4.21094 2.80566 4.21094H13.1943Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineEqual',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
